import React, { JSX } from "react";
import { NavLink } from "react-router-dom";

const BoxIcon = () => <span className="material-icons">inventory_2</span>;
const TargetIcon = () => <span className="material-icons">track_changes</span>;
const TeamIcon = () => <span className="material-icons">groups</span>;
const CashIcon = () => <span className="material-icons">payments</span>;
const SocialIcon = () => <span className="material-icons">share</span>;
const CheckIcon = () => <span className="material-icons">check_circle</span>;

type Step = { key: string; label: string; to: string; icon: JSX.Element; };

const steps: Step[] = [
    { key: "details", label: "Details", to: "/dashboard/profile/details", icon: <BoxIcon /> },
    { key: "objective", label: "Objective", to: "/dashboard/profile/objective", icon: <TargetIcon /> },
    { key: "team", label: "Team", to: "/dashboard/profile/team", icon: <TeamIcon /> },
    { key: "funding", label: "Funding", to: "/dashboard/profile/funding", icon: <CashIcon /> },
    { key: "social", label: "Social", to: "/dashboard/profile/social", icon: <SocialIcon /> },
    { key: "done", label: "Done", to: "#", icon: <CheckIcon /> },
];

export default function Stepper({ active }: { active: string }) {
    const activeIdx = steps.findIndex((s) => s.key === active);

    return (
        <div className="flex items-center gap-6 overflow-x-auto pb-2 w-full">
            {steps.map((s, idx) => { 
                const isActive = idx === activeIdx;
                const isDone = idx < activeIdx;

                const circle = [
                    "grid place-items-center transition-colors",
                    isDone || isActive
                        ? "text-[#202220]"
                        : "text-[#B8B2B2]",
                ].join(" ");

                const bar =
                    "h-[6px] rounded-full " +
                    (isDone || isActive ? "bg-[#79b987]" : "bg-[#B8B2B2]");

                const IconSized = React.cloneElement(s.icon, {
                    className: `${(s.icon.props.className ?? "")} text-[20px] leading-none`,
                });

                const Node = (
                    <div className="flex flex-col items-center gap-1">
                        <div className={circle}>{IconSized}</div>
                        <div className="text-xs text-[#6f757a]">{s.label}</div>
                    </div>
                );

                return (
                    <div key={s.key} className="flex items-center gap-2 w-full last:w-auto min-w-[110px] last:min-w-0">
                        {s.to !== "#" ? <NavLink to={s.to}>{Node}</NavLink> : Node}
                        {idx !== steps.length - 1 && (
                            <div className="w-full">
                                <div className={bar} />
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
